import { useEffect, useState, useMemo } from "react";
import { subDays, format } from "date-fns";
import PeriodDuration from "../features/supervision/analytics/data/PeriodDuration";
import ConversationCompletedService from "../features/supervision/conversations/services/ConversationCompletedService";

function useConversationDurations({ periodChoice, date_start, date_end, channel_id = null }) {
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getConversations } = ConversationCompletedService;

    const finalPeriod = useMemo(() => {
        if (periodChoice && periodChoice !== "custom") {
            const now = new Date();
            const nbDays = Math.abs(PeriodDuration[periodChoice] || 0);
            return {
                date_start: format(subDays(now, nbDays), "yyyy-MM-dd"),
                date_end: format(now, "yyyy-MM-dd"),
                channel_id : channel_id
            };
        }

        return {
            date_start,
            date_end,
            channel_id
        };
    }, [periodChoice, date_start, date_end,channel_id]);

    useEffect(() => {
        async function fetchGraphData() {
            setLoading(true);
            try {
                console.log(finalPeriod);
                const responseArray = await getConversations({
                    date_start: finalPeriod.date_start,
                    date_end: finalPeriod.date_end,
                    forGraph: true,
                    channel_id : finalPeriod.channel_id
                });

                let dataArr = [];
                if (Array.isArray(responseArray)) {
                    const item = responseArray.find((r) => r && Array.isArray(r.data));
                    dataArr = item?.data || [];
                } else if (Array.isArray(responseArray.data)) {
                    dataArr = responseArray.data;
                }

                setConversations(dataArr);
            } catch (err) {
                console.error("Erreur fetch graph calls", err);
                setConversations([]);
            } finally {
                setLoading(false);
            }
        }

        if (finalPeriod.date_start && finalPeriod.date_end) {
            fetchGraphData();
        }
    }, [periodChoice, date_start, date_end, getConversations,channel_id]);

    return { conversations, loading };
}

export default useConversationDurations;
